import { render } from "./MBranchs.vue?vue&type=template&id=4bf8e5f0"
import script from "./MBranchs.vue?vue&type=script&lang=js"
export * from "./MBranchs.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\mlab\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__